import React from 'react'
import agent from '../agent'
import TradeList from './widgets/TradeList';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import {
  TRADE_LIST_PAGE_LOADED,
  TRADE_LIST_NEXT_PAGE_LOADED,
  TRADE_LIST_PAGE_UNLOADED,
  TRADE_LIST_SEARCH_LOADED,
  UPDATE_FIELD_TRADE_LIST_SEARCHTERM,
  CHANGE_DATE_STRINGS
} from '../constants/actionTypes'
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

const mapStateToProps = state => ({
  ...state.trade,
  appName: state.common.appName,
  token: state.common.token,
  date_from: state.common.date_from,
  date_to: state.common.date_to
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, pageIndex, terms, date_from, date_to) =>
    dispatch({ type: TRADE_LIST_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to }),
  onLoadNextPage: (payload, pageIndex, terms, date_from, date_to) => {
    dispatch({ type: TRADE_LIST_NEXT_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to })
  },
  onSearch: (payload, pageIndex, terms, date_from, date_to) => {
    dispatch({ type: TRADE_LIST_SEARCH_LOADED, payload, currentPage: pageIndex, searchTerm: terms, date_from, date_to })
  },
  onChangeSearchTerm: value =>
    dispatch({ type: UPDATE_FIELD_TRADE_LIST_SEARCHTERM, key: 'searchTerm', value }),
  onChangeDateStrings: (date_from, date_to) =>
    dispatch({ type: CHANGE_DATE_STRINGS, date_from, date_to }),
  onUnload: () =>
    dispatch({ type: TRADE_LIST_PAGE_UNLOADED })
});

class Trades extends React.Component {
  constructor() {
    super()
    this.changeSearchTerm = (ev) => this.props.onChangeSearchTerm(ev.target.value)
    this.search = () => ev => {
      ev.preventDefault()
      const pageIndex = 1;
      const terms = this.props.searchTerm || ''
      const date_from = this.props.date_from || ''
      const date_to = this.props.date_to || ''
      const payload = agent.Trades.all(pageIndex, terms, date_from, date_to)
      this.props.onSearch(payload, pageIndex, terms, date_from, date_to)
    }
  }
  componentWillMount() {
    const pageIndex = 1;
    const terms = ''
    const date_from = ''
    const date_to = ''
    this.props.onLoad(agent.Trades.all(pageIndex, terms, date_from, date_to), pageIndex, terms, date_from, date_to);
  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  handlePageChanged(newPage) {
    const pageIndex = newPage + 1;
    const terms = this.props.searchTerm || ''
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''
    this.props.onLoadNextPage(agent.Trades.all(pageIndex, terms, date_from, date_to), pageIndex, terms, date_from, date_to);
  }
  handleChangeDateStrings(dates, dateStrings) {
    var unixFrom = dateStrings[0] ? moment(dateStrings[0]).format('X') : ''
    var unixTo = dateStrings[1] ? moment(moment(dateStrings[1]).format('YYYY-MM-DD 23:59:59')).format('X') : ''
    this.props.onChangeDateStrings(unixFrom, unixTo)
  }
  render() {
    const current = this.props.currentPage - 1
    const date_from = this.props.date_from ? moment(moment(this.props.date_from * 1000).format('YYYY-MM-DD')) : ''
    const date_to = this.props.date_to ? moment(moment(this.props.date_to * 1000).format('YYYY-MM-DD')) : ''

    return (
      <div class='pane'>
        <h1>Trades list</h1>
        <div className="filters">
          <div className="filterSearch">
            <RangePicker
              ranges={{ 'This Month': [moment().startOf('month'), moment()], Today: [moment(), moment()] }}
              value={[date_from, date_to]}
              onChange={this.handleChangeDateStrings.bind(this)}
            />
            <input type="text" placeholder="find by key" value={this.props.searchTerm} onChange={this.changeSearchTerm} />
            <button type="submit" onClick={this.search()}>Find</button>
          </div>
        </div>
        <TradeList trades={this.props.orders} loading={this.props.loading} />
        {
          this.props.orders && this.props.orders.length > 0 ?
            <Pager
              total={this.props.totalPage || 0}
              current={this.props.currentPage - 1}
              visiblePages={7}
              titles={{ first: '<<', last: '>>' }}
              onPageChanged={this.handlePageChanged.bind(this)}
            />
            : null
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Trades);



// WEBPACK FOOTER //
// ./src/components/Trades.js